import { useEffect, useState } from 'react';

import { Checkbox, Badge, Button } from '@mui/material';

import PropTypes from 'prop-types';

import _ from 'lodash';

import { useRouter } from 'next/router';

const BuildingFilterButton = (props) => {

    const { children, onChange } = props;

    const [openModal, setOpenModel] = useState(false);
    
    const [buildingBadgeCount, setBuildingBadgeCount] = useState(0);

    const [selectedBuildings, setSelectedBuildings] = useState(null);

    const [nearbyBuildings, setNearbyBuildings] = useState(null);

    const roomTypes = _.map(props.roomTypes, (roomType) => roomType);
    
    const buildings = _.map(props.buildings, (building) => building);

    const router = useRouter();

    const { query } = router;

    useEffect(() => {  
        getBuildingsFromQuery();     
        checkBadgeCount();
    }, [query, nearbyBuildings]);    

    useEffect(() => {
        async function asyncGetNearbyBuildingNames() {
            await getNearbyBuildingNames();
        }
        asyncGetNearbyBuildingNames();
    }, [query]);    

    const onFilterClick = () => {
        setOpenModel(true);
    };    

    const onModalClose = () => {
        setOpenModel(false);
    };

    const checkBadgeCount = () => {
        const { building } = query;
        let count = 0;
        if (building) {
            if (typeof building === 'string') {
                count += 1;
            } else {
                const buildingCount = _.size(building);

                count += buildingCount;
            }
        }
        setBuildingBadgeCount(count);
    };    

    const onBuildingSelect = (value) => {
        let buildingValues = null;
        if (_.includes(selectedBuildings, value) && !_.isEmpty(selectedBuildings)) {
            let newSelectedBuildings = _.cloneDeep(selectedBuildings);
            newSelectedBuildings = _.remove(newSelectedBuildings, (id) => id !== value);
            setSelectedBuildings(newSelectedBuildings);
            buildingValues = newSelectedBuildings;
        } else if (selectedBuildings && !_.isEmpty(selectedBuildings)) {
            if (typeof selectedBuildings === 'string') {
                setSelectedBuildings([selectedBuildings, value]);
                buildingValues = [selectedBuildings, value];
            } else {
                const options = _.cloneDeep(selectedBuildings);
                options.push(value);
                setSelectedBuildings(options);
                buildingValues = options;
            }
        } else {
            setSelectedBuildings([value]);
            buildingValues = [value];
        }
        if (onChange) {
            onChange(buildingValues);
        }        
    };

    const getNearbyBuildingNames = () => {
        const uniqueBuildingNames = _.uniq(
            _.map(roomTypes, (roomType) => `${_.get(roomType, 'buildingName')}`),
        );
        setNearbyBuildings(uniqueBuildingNames);
    };    

    const getBuildingsFromQuery = () => {
        const buildingParams = _.get(query, 'building');
        if (buildingParams) {
            const options = [];
            _.forEach(buildings, (building) => {
                if (_.includes(nearbyBuildings, _.get(building, 'name'))) {
                    if (typeof buildingParams === 'string' && buildingParams === building.id) {
                        options.push(building.id);
                    } else {
                        const foundId =
                            _.find(buildingParams, (param) => param === building.id) !== undefined;
                        if (foundId) {
                            options.push(building.id);
                        }
                    }
                }
            });
            setSelectedBuildings(options);
        } else {
            setSelectedBuildings(null);
        }
    };    

    const renderBuildingData = () => {        
        return _.map(buildings, (building, index) => {            
            return (
                <div className='building-button-filter-checkbox-line-item' key={index} onClick={() => onBuildingSelect(building.id)}>
                    <div className='building-button-filter-checkbox-wrapper'>
                        <Checkbox
                            checked={_.includes(selectedBuildings, building.id)}
                            disableRipple
                        />
                    </div>
                    <h6>{building.name}</h6>
                </div>
            );            
        });
    };

    return (
        <>
            <div id="building-filter-container" className='building-button-filter-container'>
                <Button
                    id="building-filter-button"
                    badge={buildingBadgeCount > 0 ? buildingBadgeCount : 0}
                    className={buildingBadgeCount > 0 ? 'building-filter-badge' : 'building-filter-no-badge'}
                    onClick={onFilterClick}
                >
                    <Badge badgeContent={buildingBadgeCount} >
                        {children}
                    </Badge>
                </Button>
                {openModal && (
                    <div>
                        <div className='building-button-filter-modal-overlay' onClick={onModalClose} />
                        <div id="building-filter-modal-container" className='building-button-filter-modal-container'>{renderBuildingData()}</div>
                    </div>
                )}                  
            </div>       
        </>       
    );
};

BuildingFilterButton.propTypes = {
    children: PropTypes.string,
    buildings: PropTypes.object,
    roomTypes: PropTypes.object,    
    onChange: PropTypes.func,
};

export default BuildingFilterButton;

